import React from 'react';
import { MediaElementContent } from './MediaElementContent';
import { MediaElementPlaceholder } from './MediaElementPlaceholder';
import { MediaListTitle } from '../MediaListTitle/MediaListTitle';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaElement = ({
  media,
  index,
  title = '',
  labelText
}) => /*#__PURE__*/_jsxs(PlayContainer, {
  children: [/*#__PURE__*/_jsx(MediaListTitle, {
    title: title
  }), media ? /*#__PURE__*/_jsx(MediaElementContent, {
    media: media,
    labelText: labelText,
    index: index
  }) : /*#__PURE__*/_jsx(MediaElementPlaceholder, {})]
});